import { baseUrl } from "./config";

export const getQuestions = async () => {
  try {
    const result = await fetch(`${baseUrl}/faq/`);

    if (!result.ok) {
      throw { error: true };
    }

    const data = await result.json();
    console.log(data);
    return data;
  } catch (error) {
    console.log(error);
    return { error: true };
  }
};

/* export const getQuestions = async () => {
    let list = [];
    return firebase.firestore().collection('faq').get()
        .then(querySnapshot => {
            querySnapshot.forEach(doc => {
                list.push(doc.data());
            })
            return list;
        })
        .catch(error => {
            console.log(error)
            return {error: true};
        })
} */
